import React from "react";

import styles from "./columnSelector.module.scss";

export const StyledColumnSelector: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div className={`${styles.styledColumnSelector} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const StyledColumnSelectorInputs: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div
    className={`${styles.styledColumnSelectorInputs} ${className ?? ""}`}
    {...rest}>
    {children}
  </div>
);

export const StyledSelectedColumn: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div className={`${styles.styledSelectedColumn} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);
